import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { getWeeksFromDate, isNonNullish } from '@epicuro-next/utilities';

export interface WeeksPresetData {
  [weekLabel: string]: string;
}

@Component({
  selector: 'atx-week-number',
  templateUrl: './week-number.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WeekNumberComponent {
  @Input()
  public weeksListNumber = 6; // number of weeks shown in bootstrap calendar

  @Input()
  public firstEmpty = false;

  @Input()
  public weeksPresetData: WeeksPresetData = {};

  @Input()
  public set startingDay({
    year,
    month,
    day,
  }: {
    year: number;
    month: number;
    day: number;
  }) {
    this.weekNumbers = [
      ...getWeeksFromDate(this.weeksListNumber, year, month, day),
    ];

    if (this.firstEmpty) {
      this.weekNumbers.unshift({ week: '', year: '' });
    }
  }

  public weekNumbers: { week: number | string; year: number | string }[] = [];

  public nonNullable(value: string): boolean {
    return isNonNullish(value);
  }
}
